import { paidUserControlConstants } from "./constants"

const initialState = {
	changed     : null,
	error       : null,
	isSending   : false,
	paged       : {},
	findResult  : [],
	findSending : false
}

export default function (state = initialState, action){
	switch (action.type){
		case paidUserControlConstants.Create.REQUEST:
		case paidUserControlConstants.Update.REQUEST:
		case paidUserControlConstants.Delete.REQUEST:
		case paidUserControlConstants.GetPaged.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case paidUserControlConstants.Find.REQUEST:
			return {
				...state,
				findSending: true
			}
		case paidUserControlConstants.Update.FAILURE:
		case paidUserControlConstants.Create.FAILURE:
		case paidUserControlConstants.Delete.FAILURE:
		case paidUserControlConstants.GetPaged.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case paidUserControlConstants.Find.FAILURE:
			return {
				error       : action.payload,
				findSending : false
			}
		case paidUserControlConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : "Платные пользователи успешно добавлены!"
			}
		case paidUserControlConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : "Платный пользователь успешно изменён!"
			}
		case paidUserControlConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : "Платный пользователь успешно удалён!"
			}
		case paidUserControlConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case paidUserControlConstants.Find.SUCCESS:
			return {
				...state,
				findSending : false,
				findResult  : action.payload.result
			}
		case paidUserControlConstants.Clear:
			return {
				...state,
				changed     : null,
				error       : null,
				isSending   : false,
				paged       : {},
				findResult  : [],
				findSending : false
			}
		default:
			return state
	}
}
